export const QUEUED = "Queued"
export const SUPERVISOR = "Supervisor Calls"
export const ACTIVE = "Active Calls"

export const AUDIO = "AUDIO"
export const VIDEO = "VIDEO"

export const callChannels = {
  AUDIO,
  VIDEO,
}

// How a supervisor joins a call that belongs to an interpreter.
export const BARGE = "BARGE"
export const LISTEN = "LISTEN"
export const MONITORING_MODES = [BARGE, LISTEN]

const callTypes = { QUEUED, SUPERVISOR, ACTIVE }

export default callTypes
